interface NotificationMutedIconProps {
    width?: number;
    fill?: string;
}

export const NotificationMutedIcon = ({ width = 24, fill = "var(--hop-neutral-icon)" }: NotificationMutedIconProps) => {
    return (
        <svg width={width} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                d="M7.207 9.359c0-2.69 2.154-4.857 4.793-4.857s4.794 2.167 4.794 4.857c0 3.924.617 6.003
                1.204 7.147H5.976c.59-1.124 1.23-3.177 1.23-7.147m1.305 8.647H5.096c-.276
                0-.703-.096-.932-.506-.243-.436-.067-.867.114-1.105.393-.519 1.429-2.086
                1.429-7.036 0-3.503 2.81-6.357 6.293-6.357s6.294 2.854 6.294 6.357c0 4.922
                1.01 6.537 1.402 7.045.156.202.373.623.142 1.077-.226.446-.685.525-.934.525h-3.416a3.568
                3.568 0 0 1-6.976 0m1.561 0a2.068 2.068 0 0 0 3.854 0z"
                fill={fill}
            />
            <path
                d="M2.5 2.5L21.5 21.5"
                stroke={fill}
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </svg>
    );
};
